import api from '@/api/api-endpoints'
import { createAsyncMutation, doAsyncGet } from '@/api/async-util'

const types = {
    GET_COUNTRIES: createAsyncMutation('GET_COUNTRIES'),
    GET_CURRENCIES: createAsyncMutation('GET_CURRENCIES'),
    GET_STATES: createAsyncMutation('GET_STATES'),
    GET_PROVINCES: createAsyncMutation('GET_PROVINCES'),
}

const enums = {
    state: {},
    mutations: {},
    actions: {
        // GET
        getCountries(store) {
            let url = api.enum + 'Countries'
            return doAsyncGet(store, { url, mutationTypes: types.GET_COUNTRIES })
        },
        getCanadianProvinces(store) {
            let url = api.enum + 'CanadianProvinces'
            return doAsyncGet(store, { url, mutationTypes: types.GET_PROVINCES })
        },
        getAmericanStates(store) {
            let url = api.enum + 'AmericanStates'
            return doAsyncGet(store, { url, mutationTypes: types.GET_STATES })
        },
        getCurrencies(store, payload) {
            let url = api.enum + 'Currencies'
            return doAsyncGet(store, { url, mutationTypes: types.GET_CURRENCIES })
        },

        // POST

        // PUT

        // DELETE
    },
    getters: {},
    types: types
}

export default enums
